/**
 * index.js
 * Written by: Alex Kasemir
 * Combines all of the actions contained in this directory
 */

import * as get from './getQuiz';
import * as getAll from './getQuizzes';
import * as select from './selectQuiz';
import * as goToQuiz from './goToQuiz';
import * as getQuizResults from './getQuizResults';
import * as clearQuizResults from './clearQuizResults';
import * as removeQuizQuestion from './removeQuizQuestion';
import * as getRandomQuiz from './getRandomQuiz';
import * as getTopUser from './getTopUser';
import * as skipQuizQuestion from './skipQuizQuestion';
import * as resetSession from './resetSession';

export default {
  ...get,
  ...getAll,
  ...select,
  ...goToQuiz,
  ...getQuizResults,
  ...clearQuizResults,
  ...removeQuizQuestion,
  ...getRandomQuiz,
  ...getTopUser,
  ...skipQuizQuestion,
  ...resetSession,
};
